import { cn } from "@/lib/utils";
import { RoundedButtonProps } from "./types";

const baseRoundedStyles =
  "inline-flex items-center justify-center gap-2.5 overflow-hidden rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";

const sizeStyles = {
  xs: "h-6 w-6 p-1",
  sm: "h-8 w-8 p-2",
  md: "h-10 w-10 p-2.5",
  lg: "h-12 w-12 p-3",
};

const colorVariants = {
  default: "bg-card-bg hover:bg-gray-700 focus:ring-gray-500",
};

export const RoundedButton = ({ children, href, size = "md", className, ...props }: RoundedButtonProps) => {
  const Component = href ? "a" : "button";

  return (
    <Component
      href={href}
      className={cn(baseRoundedStyles, sizeStyles[size], colorVariants.default, className)}
      {...props}
    >
      {children}
    </Component>
  );
};
